import { deserialize } from 'libs/cerialize';
import { deserializeAs } from 'libs/cerialize';

export class ProcessCardPageModel {
	@deserialize
	Id: number;

	@deserialize
	Name: string;
}